import $ from 'jquery';
window.$ = window.jQuery = $;

$(document).ready(function($) {
  $('.side-nav-hold .has-children>a').click(function(event) {
    event.preventDefault();
    $(this).parent().toggleClass('active');
  });

  $('.top-navbar .hamburger').click(function(event) {
    event.preventDefault();
    $(this).toggleClass('is-active');
    $('body.dashboard #app').toggleClass('nav-open');
  });
});